import { IntlShape } from 'react-intl';
import * as Yup from 'yup';
export const packedSchemaValidation = (intl: IntlShape) =>
  Yup.object().shape({
    trackingNumber: Yup.string(),
  });
